import { Theme } from '@material-ui/core'

export const styles = (theme: Theme) => ({
  card: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
    marginLeft: theme.spacing(0) + ' !important',
    marginRight: theme.spacing(0) + ' !important',
    paddingLeft: theme.spacing(0) + ' !important',
    paddingRight: theme.spacing(0) + ' !important'
  }
})
